import { RootState } from "@/app/stores";
import { getTradingPartners, getTransactions, IListTransactionsResults, ITradingPartner } from "@/shared/api/trading";
import { ErrorType } from "@/shared/types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

export const fetchTransactions = createAsyncThunk<
    IListTransactionsResults,
    void,
    { state: RootState }
>(`socialMarketTransactions/fetchTransactions`, async (_, thunkAPI) => {
    try {
        const { cursor, count, startDate, endDate, selectedPartner, destType } = thunkAPI.getState().socialMarketTransactions
        const response = await getTransactions(count, cursor, startDate, endDate, selectedPartner ? [selectedPartner] : null, destType ? [destType] : null)
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchTradingPartners = createAsyncThunk<
    ITradingPartner[],
    void,
    { state: RootState }
>('socialMarketTransactions/fetchTradingPartners', async (_, thunkAPI) => {
    try {
        const response = await getTradingPartners(null)
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})